/**
 * ＣＷＳカテゴリマスタ用VOクラス
 *
 * @export KYMW5300commonModel
 * @class KYMW5300commonModel
 */
export class KYMW5300commonModel {

  // 共通パラメータ
  // カテゴリ商品マスタ項目
  /** 受注コード */
  public orderCode = String('');

  /** 在庫限定フラグ */
  public stockLimitFlg = String('0');

  // カテゴリマスタ/カテゴリ商品マスタ項目
  /** カテゴリコード */
  public categoryCode = String('');
  /** カテゴリ名称 */
  public categoryName = String('');
  /** 親カテゴリコード */
  public categoryParent = String('');
  /** カテゴリ階層 */
  public categoryLevel: number;
  /** 表示順 */
  public showSeq: number;

  // カテゴリ商品マスタ項目
  /** ボーダーライン区分 */
  public borderLineDiv = String('');
  /** 一時非表示区分 */
  public showDiv = String('');
  /** 売場毎表示区分 */
  public sellAreaDiv = String('');

  /** 売場毎表示区分 */
  public SellAreaDiv = String('');

  // カテゴリマスタ/カテゴリ商品マスタ項目
  /** 登録日時 */
  public registDate = String('');
  /** 登録ユーザ */
  public registUser = String('');
  /** 更新日時 */
  public updateDate = String('');
  /** 更新ユーザ */
  public updateUser = String('');

  // カテゴリマスタ項目
  /** 移動区分(0：上移動、1:下移動 */
  public moveDiv = String('');
  /** 移動数（表示順）*/
  public moveSeq: number;

  // カテゴリマスタ/カテゴリ商品マスタ項目
  /** 0:初期化、 */
  public eventFlg = String('0');
  // 1:ルート新規追加
  // 2:子追加
  // 3:削除
  // 4,5:矢印
  // 6:更新

  /** カテゴリ区分 */
  public categoryDiv = String('0');

}
